/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import HomePageMeta from "@/src/containers/Pages/Generic/HomePage/HomePageMeta";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import PartnersSection from "@/src/components/Sections/Generic/PartnersSection/PartnersSection";
import { logout } from "@/src/store/login/actions";
import StatisticsSection from "@/src/components/Sections/Generic/StatisticSection/StatisticsSection";
import AreasOfLawOverview from "@/src/components/Sections/Generic/AreasOfLawOverview/AreasOfLawOverview";
import OurService from "@/src/components/Sections/Generic/OurService/OurService";
import ServiceworldHero from "@/src/components/Sections/Generic/ServiceworldHero/ServiceworldHero";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import ValueProposition from "@/src/components/Sections/Generic/ValueProposition/ValueProposition";
import { useQueryClient } from "@tanstack/react-query";

const HomePage = () => {

  const queryClient = useQueryClient();

  useEffect(() => {
    logout(queryClient);
  }, []);

  return (
    <LayoutPublicRoutes>
      <HomePageMeta />
      <ServiceworldHero />
      <ValueProposition />
      <AreasOfLawOverview />
      <StatisticsSection />
      <OurService />
      <PartnersSection />
      <CustomerFeedback />
    </LayoutPublicRoutes>
  );
};

export default HomePage;
